import React from 'react';
import { Box, List, ListItem, ListItemButton, ListItemText, Typography, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const metricLayers = [
  { id: 'totalChitalishta', label: 'Брой читалища' },
  { id: 'stateSubsidyAmount', label: 'Държавна субсидия' },
  { id: 'stateSubsidyPerCapita', label: 'Субсидия на човек' },
  { id: 'revenueFromSubsidiesPercent', label: 'Приходи от субсидии (%)' },
  { id: 'expensesForSalariesPercent', label: 'Разходи за заплати (%)' },
  { id: 'totalStaff', label: 'Общ персонал' },
  { id: 'staffHigherEducationPercent', label: 'Персонал с висше образование (%)' },
  { id: 'averageInsuranceIncome', label: 'Среден осигурителен доход' },
  { id: 'chitalishtaPer10kResidents', label: 'Читалища на 10 000 жители' },
];

const MapDashboard = ({ selectedLayer, onLayerChange, onClose }) => {
  return (
    <Paper 
      elevation={4} 
      sx={{ 
        p: 2, 
        position: 'absolute', 
        top: 10, 
        left: 50, 
        zIndex: 1000, 
        width: 300, 
        maxHeight: 'calc(100% - 20px)',
        overflowY: 'auto',
        bgcolor: 'rgba(255, 255, 255, 0.9)'
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" gutterBottom>
          Слоеве на картата
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {metricLayers.map((layer) => (
          <ListItem key={layer.id} disablePadding>
            <ListItemButton
              selected={selectedLayer === layer.id}
              onClick={() => onLayerChange(layer.id)}
            >
              <ListItemText primary={layer.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default MapDashboard;